import { render } from "./legoModalExtendV2.vue?vue&type=template&id=8eca590a&scoped=true"
import script from "./legoModalExtendV2.vue?vue&type=script&lang=js"
export * from "./legoModalExtendV2.vue?vue&type=script&lang=js"

import "./legoModalExtendV2.vue?vue&type=style&index=0&id=8eca590a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eca590a"],['__file',"src/components/lego/extend/legoModalExtendV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8eca590a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8eca590a', __exports__)) {
    api.reload('8eca590a', __exports__)
  }
  
  module.hot.accept("./legoModalExtendV2.vue?vue&type=template&id=8eca590a&scoped=true", () => {
    api.rerender('8eca590a', render)
  })

}


export default __exports__